angular.module('leanlaw').directive('llHorizontalInvoiceFilter', ['invoiceFilterService', function (invoiceFilterService) {
  return {
    restrict: 'EA',
    template: require('../directives/views/filterView.html'),
    controller: ['$scope', function ($scope) {
      $scope.state = invoiceFilterService.state;
      $scope.data = {
        expenseFilter: !!$scope.state.expenseRange,
        expenseRange: $scope.state.expenseRange ? $scope.state.expenseRange : {}
      };
      $scope.expenseChange = function () {
        if ($scope.data.expenseFilter) {
          $scope.data.expenseRange = angular.copy($scope.state.range);
          $scope.state.expenseRange = $scope.data.expenseRange;
        } else {
          $scope.state.expenseRange = null;
        }
      };
      $scope.$watch('data.expenseRange', range => {
        $scope.state.expenseRange = $scope.data.expenseFilter ? range : null;
      }, true);
    }]
  };
}]);